import React from 'react'
import { trackCalendlyOpen } from '../lib/analytics'

interface CalendlyButtonProps {
  children: React.ReactNode
  className?: string
  variant?: 'primary' | 'secondary' | 'outline'
}

const CALENDLY_URL = import.meta.env.VITE_CALENDLY_URL || 'https://calendly.com/demirix'

const CalendlyButton = ({
  children,
  className = '',
  variant = 'primary'
}: CalendlyButtonProps) => {

  const getVariantClasses = () => {
    switch (variant) {
      case 'secondary':
        return 'btn-secondary'
      case 'outline':
        return 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white dark:border-white dark:text-white dark:hover:bg-white dark:hover:text-gray-900 font-semibold py-4 px-8 rounded-lg transition-all duration-200'
      default:
        return 'btn-primary'
    }
  }

  const handleClick = () => {
    trackCalendlyOpen()
    window.open(CALENDLY_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <button
      onClick={handleClick}
      className={`${getVariantClasses()} ${className}`}
    >
      {children}
    </button>
  )
}

export default CalendlyButton
